<template>
  <div class="Warning">
    <topTitle title="联系我们" :list="list" :newData="newData"></topTitle>
    <h1>最新岗位</h1>
    <div class="item_bd">
      <div class="item" v-for="(item,index) in listContent" :key="index" v-html="item.content">
        <!-- <div class="item_top">
          <div class="item_top_title">会员管家</div>
        </div>
        <div class="item_bottom">
          <p>招聘公司：</p>
          <p>工作地点：</p>
          <p>招聘对象：</p>
          <p>招聘人数：</p>
          <p>招聘部门：</p>
        </div> -->
      </div>
      <!-- <div class="item">
        <div class="item_top">
          <div class="item_top_title">销售专员</div>
        </div>
        <div class="item_bottom">
          <p>招聘公司：</p>
          <p>工作地点：</p>
          <p>招聘对象：</p>
          <p>招聘人数：</p>
          <p>招聘部门：</p>
        </div>
      </div> -->
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "Warning",
  data() {
    return {
      list: [
        {
          title: "联系我们",
          small_title: "CONTACT US",
          hasTitle: "联系我们",
          show: false,
        },
        {
          title: "加入我们",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "加入我们",
        },
      ],
        newData:1,
        listContent:[]
    };
  },
  methods: {},
  mounted: function () {
    axios
        .get(
         
           "/api/article/paginate?categoryId=4&pageNumber=1"
        )
        .then((res) => {
        
          if(res.status=='200'){
            this.listContent=res.data.page.list;
           
          }
         
        });
  },
  components: {
    topTitle,
  },
  props: {
  
  
  },
};
</script>
<style scoped="scoped">
h1 {
  color: #3f674b;
  text-align: left;
  margin: 0.6875rem 0.8rem;
}
.item_bd {
  width: 100%;
  padding: 0 0.675rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.item {
  width: 4.9375rem;
height: 6.625rem;
  border: 2px solid #bbb389;
  border-radius: 10px;
   display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items:center;
  /* padding-left: 0.375rem; */
  padding: 0  0.375rem 0.5rem;

  font-size: 0.3rem;
  font-family: PingFang SC;
  font-weight: 400;
  /* color: #3f674b; */
  margin-bottom: 0.25rem;
}
.item>>>p{
  width: 100%;
  text-align: left;
  display: flex;
  /* justify-content: center; */
}
 .item>>>p:first-of-type{
   height: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* color: red; */
}

.item>>>p:first-of-type>strong{
  width: 3.125rem;
  height: 100%;
  border-bottom: 1px solid #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.4rem;
  font-family: PingFang SC;
  /* font-weight: 500; */
  color: #3f674b;
  
}
.item>>>strong{
  white-space: nowrap;
font-size: 0.3rem;
font-family: PingFang SC;
font-weight: 400;
color: #40684B;
}
/* .item_top {
  height: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item_top_title {
  width: 3.125rem;
  height: 100%;
  border-bottom: 1px solid #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3f674b;
} */
.item_bottom {
  height: calc(100% - 1.25rem);
 
}
</style>